import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Set favicon
const setFavicon = () => {
  // Remove existing favicons
  const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
  existingFavicons.forEach(favicon => favicon.remove());
  // Add new favicon (32x32)
  const favicon32 = document.createElement('link');
  favicon32.rel = 'icon';
  favicon32.type = 'image/png';
  favicon32.sizes = '32x32';
  favicon32.href = 'https://cdn.magicpatterns.com/uploads/k5fNtmwc2mFs1AhwSeu33E/FDF_Gold_Logo.png';
  document.head.appendChild(favicon32);
  // Add favicon (16x16)
  const favicon16 = document.createElement('link');
  favicon16.rel = 'icon';
  favicon16.type = 'image/png';
  favicon16.sizes = '16x16';
  favicon16.href = 'https://cdn.magicpatterns.com/uploads/k5fNtmwc2mFs1AhwSeu33E/FDF_Gold_Logo.png';
  document.head.appendChild(favicon16);
  // Add Apple Touch Icon
  const appleTouchIcon = document.createElement('link');
  appleTouchIcon.rel = 'apple-touch-icon';
  appleTouchIcon.sizes = '180x180';
  appleTouchIcon.href = 'https://cdn.magicpatterns.com/uploads/k5fNtmwc2mFs1AhwSeu33E/FDF_Gold_Logo.png';
  document.head.appendChild(appleTouchIcon);
};
setFavicon();
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-270">
    <App data-id="element-271" />
  </React.StrictMode>);